<template>
    <div>
        <div class="tab-item" >
            <!-- <div class="btn">
            </div> -->
            <!-- <div class="red">
                <span v-if="themeDetail.needVerify == 1">需要场勘</span>
                <span v-else>不需要场勘</span>
                <span>/</span>
                <span v-if="themeDetail.needConstruct == 1">需要搭建</span>
                <span v-else>不需要搭建</span>
            </div>
            <div class="item">
                <div class="left">是否需要SPR</div>
                <div class="right">
                    <span v-if="themeDetail.needSpr == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div> -->
            <!-- <div class="item">
                <div class="left">是否需要督导打卡</div>
                <div class="right">
                    <span v-if="themeDetail.needSupervisor == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div> -->
            <!-- <div class="item">
                <div class="left">是否需要转场</div>
                <div class="right">
                    <span v-if="themeDetail.needTransitions == 1">是</span>
                    <span v-else> 否</span>
                </div>
            </div> -->
            <!-- <div class="item">
                <div class="left">装饰点位</div>
                <div class="right">
                    <span v-if="themeDetail.themeDecorates">
                        {{getDecorates(themeDetail.themeDecorates,'、')}}
                    </span>
                    <span v-else>暂无</span>
                </div>
            </div> -->
            <!-- <div class="item"  v-if="themeDetail.pocRelateType == '2'">
                <div class="left">最少关联售点数</div>
                <div class="right">
                    <span v-if="themeDetail">
                        {{pocCountMin}}
                    </span>
                </div>
            </div> -->
            <!-- <div class="item-ignite" v-if="themeDetail.pocRelateType == '1' || themeDetail.pocRelateType == '2'">
                <div class="left">IGNITE查询规则配置</div>
                <div class="right">
                    <div v-for="item in this.ingiteAllarr" :key="item.regionCode">
                        <div v-if="item.regionCode == childregionCode">
                            <div v-if="item.igniteRuleObj.igniteStatus.length > 0 || item.igniteRuleObj.openStatus.length > 0 ||
                                item.igniteRuleObj.bizForm.length > 0 || item.igniteRuleObj.pocGrade.length > 0 ||
                                item.igniteRuleObj.salesVolume.length > 0">
                                <span class="right10" style="color:#cd1231">{{ item.regionName.split('|')[0] }}</span>
                                <span v-if="item.igniteRuleObj.openStatus.length > 0 " class="right10">售点状态:</span>
                                <span>{{getOptionsName(item.igniteRuleObj.openStatus,'、',igniteOptions.openStatus)}}</span>

                                <span v-if="item.igniteRuleObj.bizForm.length > 0" class="right15" >|</span>
                                <span v-if="item.igniteRuleObj.bizForm.length > 0" class="right10">业态:</span>
                                <span>{{getOptionsName(item.igniteRuleObj.bizForm,'、',igniteOptions.bizForm)}}</span>

                                <span v-if="item.igniteRuleObj.pocGrade.length > 0" class="right15">|</span>
                                <span v-if="item.igniteRuleObj.pocGrade.length > 0" class="right10">档次:</span>
                                <span>{{getOptionsName(item.igniteRuleObj.pocGrade,'、',igniteOptions.pocGrade)}}</span>

                                <span v-if="item.igniteRuleObj.salesVolume.length > 0"  class="right15">|</span>
                                <span v-if="item.igniteRuleObj.salesVolume.length > 0"  class="right10">销售潜力:</span>
                                <span>{{getOptionsName(item.igniteRuleObj.salesVolume,'、',igniteOptions.salesVolume)}}</span>

                            </div>
                            <div v-else>
                                <span class="right10" style="color:#cd1231">{{ item.regionName.split('|')[0] }}</span>
                                <span>无IGNITE查询规则限制</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="item" v-if="themeDetail.needTransitions == 1">
                <div class="left">道具数量</div>
                <div class="right">
                    <span>{{ themeDetail.itemQuantity }}</span>
                </div>
            </div>
            <div class="item" v-else>
                <div class="left">
                    <span v-if="themeDetail.pocRelateType == '1'">每售点执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '2'">每街区执行天数</span>
                    <span v-if ="themeDetail.pocRelateType == '0'">每活动地点执行天数</span>
                </div>
                <div class="right">
                    <span>{{themeDetail.perExecDays}}</span>
                </div>
            </div> -->
            <!-- <div class="item" >
                <div class="left">额度信息</div>
                <div class="right right-edu">
                    <div class="item-number" v-for="(item) in themeDetail.detailDTOList" :key="item.regionCode">
                        <div v-if="item.totalCountQty > 0">
                            <span style="margin:0px 5px 0px 0px;">{{getRegionName(item.regionName)}}</span>
                            <span>{{item.totalCountQty}}{{ showText }}</span>
                            <span>（已通过：</span>
                            <span>{{item.passedCountQty}}{{ showText }}</span>
                            <span style="margin:0px 5px;">/</span>
                            <span>审核中：</span>
                            <span>{{item.approvalCountQty}}{{ showText }}</span>
                            <span style="margin:0px 5px;">/</span>
                            <span>未提报：</span>
                            <span>{{item.notReportCountQty}}{{ showText }}</span>
                            <span>）</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="item-sale2">
                <!-- <div class="div1" >
                    <span style="color:#cd1231;margin-left:-8px" v-if="tableData.length == 0">*</span><span>售点信息</span>
                </div> -->
                <div class="div2"  v-for="timeItem in timeList" :key="timeItem.assignId">
                    <div v-if="themeDetail.needTransitions == '1' ">
                        <!-- newTime < timeItem.assignStartTime && -->
                        <div>
                            <PopTable
                            :detailDTOList='detailDTOList'
                            :timeItem="timeItem"
                            :popDataitem="popDataitem"
                            :igniteOptions="igniteOptions"
                            :regionCode="regionCode"
                            :showText = 'showText'
                            :isChange = true
                            :gpActivityInfoVOList="gpActivityInfoVOList"
                            @addPopsale="addPopsale"
                            @getChildcode="getChildcode"
                            @setLoading="setLoading"
                            ></PopTable>
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            <PopTable
                            :detailDTOList='detailDTOList'
                            :timeItem="timeItem"
                            :popDataitem="popDataitem"
                            :igniteOptions="igniteOptions"
                            :regionCode="regionCode"
                            :showText = 'showText'
                            :isChange = false
                            :gpActivityInfoVOList="gpActivityInfoVOList"
                            @addPopsale="addPopsale"
                            @getChildcode="getChildcode"
                            @setLoading="setLoading"
                            ></PopTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from "@/utils/common"
    import PopTable from './activity-report-add-pop-table.vue'
    import gameplanApi from '../../../api/gameplan'
    export default {
      name: 'activity-report-add-pop-form',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        igniteOptions:{type:Object, default:()=>{} },
        regionCode:{type:String, default:'' },
        gpActivityInfoVOList:{type:Array, default:()=>[] },
      },
      components: {
        PopTable
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            pocCountMin:'', //最小关联售点
            popData:[],
            notReportCountQty:'', // 未提报
            igniteRuleDTOList:[],
            newTime:'',
            timeList: [],
            detailDTOList: [],
            childregionCode:'',
            addNum: '',
            ingiteAllarr: []
        }
      },
      computed: {
        // ...mapGetters(['userInfo']),
        updateNumer () {
            let num = this.tableData.map(item =>{
                return num + item.timeList.length
            })
            return this.themeDetail.notReportCountQty - num
        },
        showText () {
            if(this.themeDetail.needTransitions == '1') {
                return '场'
            } else {
                if (this.themeDetail.pocRelateType == '1') {
                    return '售点'
                } else if (this.themeDetail.pocRelateType == '0') {
                    return '地点'
                } else if (this.themeDetail.pocRelateType == '2') {
                    return '街区'
                } else {
                    return ''
                }
            }
        }
      },
      watch: {},
      created () {
        this.popData = this.popDataitem
        this.themeDetail =  this.popDataitem.themeDetail || {}
        let arr = []
        let num = 0
        if(this.themeDetail.detailDTOList){
            for (let item of this.themeDetail.detailDTOList) {
                //if (item.notReportCountQty > 0) {
                    arr.push(item)
                    num = num + item.notReportCountQty
                //}
            }
        }
        this.addNum = num
        this.detailDTOList = arr
        // this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        // this.igniteRuleDTOList =  this.popDataitem.igniteRuleDTOList
        this.timeList.push({
            'assignStartTime':'',
            'assignEndTime':'',
            'notReportCountQty':100,
            'assignId':'',
        })
        // if (this.popDataitem.themeLevelCode !== null) {
        //     this.popData = this.popDataitem
        //     this.themeDetail =  this.popDataitem.themeDetail
        //     this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        //     this.igniteRuleDTOList =  this.popDataitem.igniteRuleDTOList
        //     if ( this.igniteRuleDTOList == null) {
        //         let mapArr = []
        //         for (let item of this.themeDetail.detailDTOList) {
        //             if (item.notReportCountQty > 0) {
        //                 mapArr.push(item)
        //             }
        //         }
        //         this.igniteRuleDTOList = [{
        //             'igniteRuleObj':{
        //                     "igniteStatus": [],
        //                     "openStatus": [],
        //                     "channel": [],
        //                     "bizForm": [],
        //                     "subBizForm": null,
        //                     "pocGrade": [],
        //                     "salesVolume": [],
        //                     "pocName": null,
        //                     "themeDetailId": null
        //             },
        //             'igniteMappingDTOList':mapArr
        //         }]
        //     }
        //     let arr = []
        //     for (let item1 of  this.igniteRuleDTOList) {
        //         if (item1.igniteMappingDTOList == null) {
        //             item1.igniteMappingDTOList = [
        //                 {
        //                     'regionCode':"",
        //                     'regionName':""
        //                 }
        //             ]
        //         }
        //         for (let item2 of item1.igniteMappingDTOList) {
        //             arr.push(
        //                 {
        //                     'igniteRuleObj':item1.igniteRuleObj,
        //                     'regionName':item2.regionName,
        //                     'regionCode':item2.regionCode
        //                 }
        //             )
        //         }
        //     }
        //     for (let i = 0; i < arr.length; i++) {
        //         for (let j = i + 1; j < arr.length; j++) {
        //             // 后面数据的若跟前一项数据相同，则重复，需要去除。
        //             if (arr[i].regionCode == arr[j].regionCode) {
        //                 arr.splice(j, 1); // 去除后面的相同项
        //                 j--;
        //             }
        //         }
        //     }
        //     this.igniteRuleDTOList =  arr
        // } else {
        //     this.popData = this.popDataitem.data[0]
        //     this.themeDetail =  this.popDataitem.data[0].themeDetail
        //     this.pocCountMin =  this.popDataitem.data[0].themeDetail.pocCountMin
        //     this.igniteRuleDTOList =  this.popDataitem.data[0].igniteRuleDTOList
        //     if ( this.igniteRuleDTOList == null) {
        //         let mapArr = []
        //         for (let item of this.themeDetail.detailDTOList) {
        //             if (item.notReportCountQty > 0) {
        //                 mapArr.push(item)
        //             }
        //         }
        //         this.igniteRuleDTOList = [{
        //             'igniteRuleObj':{
        //                     "igniteStatus": [],
        //                     "openStatus": [],
        //                     "channel": [],
        //                     "bizForm": [],
        //                     "subBizForm": null,
        //                     "pocGrade": [],
        //                     "salesVolume": [],
        //                     "pocName": null,
        //                     "themeDetailId": null
        //             },
        //             'igniteMappingDTOList':mapArr
        //         }]
        //     }
        //     let arr = []
        //     for (let item1 of  this.igniteRuleDTOList) {
        //         if (item1.igniteMappingDTOList == null) {
        //             item1.igniteMappingDTOList = [
        //                 {
        //                     'regionCode':"",
        //                     'regionName':""
        //                 }
        //             ]
        //         }
        //         for (let item2 of item1.igniteMappingDTOList) {
        //             arr.push(
        //                 {
        //                     'igniteRuleObj':item1.igniteRuleObj,
        //                     'regionName':item2.regionName,
        //                     'regionCode':item2.regionCode
        //                 }
        //             )
        //         }
        //     }
        //     for (let i = 0; i < arr.length; i++) {
        //         for (let j = i + 1; j < arr.length; j++) {
        //             // 后面数据的若跟前一项数据相同，则重复，需要去除。
        //             if (arr[i].regionCode == arr[j].regionCode) {
        //                 arr.splice(j, 1); // 去除后面的相同项
        //                 j--;
        //             }
        //         }
        //     }
        //     this.igniteRuleDTOList =  arr
        //     // console.log(arr,'arrrrrrrrr-null1111');
        //     // if (arr.length > 0) {
        //     //     this.childregionCode = arr[0].regionCode
        //     // }
        //     // console.log(arr,'arrrrrrrrr-null');
        // }

        // for (let item1 of this.popData.curAssignList) {
        //     this.timeList.push({
        //         'assignStartTime':item1.assignStartTime,
        //         'assignEndTime':item1.assignEndTime,
        //         'notReportCountQty':item1.notReportCountQty,
        //         'assignId':item1.assignId,
        //     })
        // }
        // console.log( this.timeList,'timeList');
        // console.log( this.popData,'popData');
        // this.newTime = new Date().getTime()
        // let arr = []
        // let num = 0
        // let arrAll = []
        // for (let item of this.themeDetail.detailDTOList) {
        //     arrAll.push(item)
        //     if (item.notReportCountQty > 0) {
        //         arr.push(item)
        //         num = num + item.notReportCountQty
        //     }
        // }
        // this.addNum = num
        // for (let item1 of this.igniteRuleDTOList) {
        //     for (let item2 of arr) {
        //         if (item1.regionCode == item2.regionCode) {
        //             item2.igniteRuleObj = item1.igniteRuleObj
        //         }
        //     }
        //     for (let item3 of arrAll) {
        //         if (item1.regionCode == item3.regionCode) {
        //             item3.igniteRuleObj = item1.igniteRuleObj
        //         }
        //     }
        // }
        // for (let item3 of arrAll) {
        //     if (!item3.igniteRuleObj || item3.igniteRuleObj == null) {
        //         item3.igniteRuleObj={
        //             "igniteStatus": [],
        //             "openStatus": [],
        //             "channel": [],
        //             "bizForm": [],
        //             "subBizForm": [],
        //             "pocGrade": [],
        //             "salesVolume": [],
        //             "pocName": [],
        //             "themeDetailId": []
        //         }
        //     }
        // }
        // for (let item3 of arr) {
        //     if (!item3.igniteRuleObj || item3.igniteRuleObj == null) {
        //         item3.igniteRuleObj={
        //             "igniteStatus": [],
        //             "openStatus": [],
        //             "channel": [],
        //             "bizForm": [],
        //             "subBizForm": [],
        //             "pocGrade": [],
        //             "salesVolume": [],
        //             "pocName": [],
        //             "themeDetailId": []
        //         }
        //     }
        // }
        // this.detailDTOList = arr
        // this.ingiteAllarr = arrAll
        // this.childregionCode = arrAll[0].regionCode
      },
      mounted () {},
      updated() {},
      methods: {
        init () {},
        getRegionName (name) {
            if (name) {
                return name.split('|')[0] + ":"
            }else {
                return '无'
            }
        },
        getOptionsName(a,b,g) {
            let c = a;
            let d = []
            let e = g
            let f = []
            for (let i in e) {
                let obj = {}
                obj[i] = e[i]
                for (let i2 of c) {
                    if (i == i2) {
                        f.push(e[i])
                    }
                }
            }
            let arr = f.map((item) => {
                    return item
                }).join(b)
            return arr
        },
        getDecorates(a,b){
            let arr = a.map((item) => {
                    return item.decorateName
                }).join(b)
            return arr
        },
        addPopsale(item) {
            this.$emit('addPopsale',item)
        },
        getChildcode(val){
            // console.log(val,'val--child');
            this.childregionCode = val
        },
        setLoading (val) {
            this.$emit('setLoading',val)
        },
    }
}
</script>
<style lang="scss" scoped>
.tab-item {
    // padding: 0px 30px 30px 30px;
    padding: 0px 0px 0px 0px;
    // background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    font-size: 14px;
    text-align: left;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }
    .btn {
        display: flex;
        width: 20%;
        margin-left: 80%;
        height: 42px;
    }
    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -40px;
        height: 32px;
        line-height: 32px;
    }
    .item {
        // height: 40px;
        line-height: 32px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
        }
        .right-edu{
            display: flex;
            flex-wrap: wrap;
            .item-number {
                width: 100%;
                // width: 50%;
            }
        }
    }
    .item-ignite {
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
            // height: 70px;
            // line-height: 70px;
            line-height: 35px;
        }
        .right {
            flex: 1;
            // height: 35px;
            // width: 65%;
            line-height: 35px;
            display: flex;
            flex-wrap: wrap;
            .right-item {
                line-height: 35px;
                display: flex;
                flex-wrap: wrap;
            }
            .right10 {
                margin-right: 10px;
            }
            .right15 {
                margin: 0 15px;
            }
        }
    }
    .item-sale {
        .left {
            // width: 90%;
            height: 42px;
            line-height: 42px;
            display: flex;
            .div1 {
                width: 20%;
                font-size: 16px;
                font-weight: bold;
            }
            .div2 {
                width: 75%;
                display: flex;
                justify-content: flex-end;
            }
        }
        .right {
            // width: 80%;
            // margin-left: 10%;
            width: 90%;
            margin-left: 5%;
            margin-top: 10px;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
                // font-weight: normal !important;
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .store-name {
                color: #409EFF;
                cursor: pointer;
            }
            .input-baiwei {
                color: #CD1231;
                ::v-deep .el-input__inner {
                    color: #CD1231;
                }

            }
        }
    }
    .item-sale2 {
        .div1 {
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            line-height: 42px;
        }
        .div2 {
            width: 100%;
        }
    }
}
</style>
